<!-- 底部导航栏 -->
<style>
</style>
<template>
    <div class="d-flex bg-dark bg-opacity-75 text-light d-sm-none position-relative">
        <div class="flex-grow-1 row align-items-center">
            <div class="col text-center py-1 d-flex flex-column" :class="{'text-info':isCheckMenu('chat'),'index-1053':$root.teachIndex==0&&$root.isShowTeach}" @click="$root.goPage('help',$root.callInfo,{id:userInfo.guid,name:userInfo.id,type:1,guid:guid})" role="button">
                <i class="bi bi-chat-dots-fill fs-4"></i>
                <span>{{$t("nav.chat")}}</span>
            </div>
            <div class="col text-center py-1 d-flex flex-column" :class="{'text-info':isCheckMenu('home')}" @click="$root.goPage('home')" role="button">
                <i class="bi bi-house-fill fs-4"></i>
                <span>{{$t("nav.home")}}</span>
            </div>
            <div class="col text-center py-1 d-flex flex-column" :class="{'text-info':isCheckMenu('personal'),'index-1053':$root.teachIndex==1&&$root.isShowTeach}" @click="$root.goPage('personal')" role="button">
                <i class="bi bi-gear-fill fs-4"></i>
                <span>{{$t("nav.personal")}}</span>
            </div>
        </div>
        <div class="d-flex align-items-center px-3 my-2 border-start border-secondary index-12">
            <i :class="[isShowTask?'bi-chevron-right':'bi-chevron-left']" class="bi fs-3 lh-1" @click="$emit('task-switch')"></i>
        </div>
    </div>
</template>
<script>
import task from "@/components/public/task.vue";
export default {
    components:{
        task
    },
    props:{
        //是否显示所有活动任务图标
        isShowTask:{
            type:Boolean,
            default:false
        },
    },
    data(){
        return {
            
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo;
        },
    },
    methods: {
        /**
         * 是否选中当前菜单
         */
        isCheckMenu(menuName){
            if(this.$route.name==menuName){
                return true;
            }
            return false;
        },
    },
};
</script>